import uuidv4 from 'uuid';
import lookerApi from '../services/looker-api';
import { updateFilters } from './filters-actions';
import { parseFilters, addAsyncLabels } from '../utils/filters';

export const REPORT_RESET = 'REPORT_RESET';
export const REPORT_UPDATE_STATE = 'REPORT_UPDATE_STATE';
export const REPORT_CHANGE_DATA = 'REPORT_CHANGE_DATA';

export const REPORT_VIEWS_REQUEST = 'REPORT_VIEWS_REQUEST';
export const REPORT_VIEWS_SUCCESS = 'REPORT_VIEWS_SUCCESS';
export const REPORT_VIEWS_ERROR = 'REPORT_VIEWS_ERROR';

export const REPORT_VIEW_REQUEST = 'REPORT_VIEW_REQUEST';
export const REPORT_VIEW_SUCCESS = 'REPORT_VIEW_SUCCESS';
export const REPORT_VIEW_ERROR = 'REPORT_VIEW_ERROR';
export const REPORT_VIEW_IGNORE = 'REPORT_VIEW_IGNORE';

export const REPORT_LIST_REQUEST = 'REPORT_LIST_REQUEST';
export const REPORT_LIST_SUCCESS = 'REPORT_LIST_SUCCESS';
export const REPORT_LIST_ERROR = 'REPORT_LIST_ERROR';

export const REPORT_REQUEST = 'REPORT_REQUEST';
export const REPORT_SUCCESS = 'REPORT_SUCCESS';
export const REPORT_ERROR = 'REPORT_ERROR';

export const resetReport = () => ({
  type: REPORT_RESET
});

export const updateState = ({ state }) => ({
  type: REPORT_UPDATE_STATE,
  state
});

export const changeData = ({ data }) => ({
  type: REPORT_CHANGE_DATA,
  data
});

const requestViews = () => ({
  type: REPORT_VIEWS_REQUEST
});

const loadViews = ({ data, availableFilters }) => ({
  type: REPORT_VIEWS_SUCCESS,
  data,
  availableFilters
});

const errorViews = error => ({
  type: REPORT_VIEWS_ERROR,
  error
});

const requestCustomView = ({ requestUUID, specs }) => ({
  type: REPORT_VIEW_REQUEST,
  requestUUID,
  specs
});

const loadCustomView = ({ requestUUID, specs, result }) => ({
  type: REPORT_VIEW_SUCCESS,
  requestUUID,
  specs,
  result
});

const errorCustomView = ({ requestUUID, specs, error }) => ({
  type: REPORT_VIEW_ERROR,
  requestUUID,
  specs,
  error
});

export const ignoreCustomViewRequest = () => ({
  type: REPORT_VIEW_IGNORE
});

const requestReportList = ({ userId }) => ({
  type: REPORT_LIST_REQUEST,
  userId
});

const loadReportList = ({ userId, data }) => ({
  type: REPORT_LIST_SUCCESS,
  userId,
  data
});

const errorReportList = ({ userId, error }) => ({
  type: REPORT_LIST_ERROR,
  userId,
  error,
});

const requestReport = ({ uuid }) => ({
  type: REPORT_REQUEST,
  uuid
});

const loadReport = ({ uuid, ...rest }) => ({
  type: REPORT_SUCCESS,
  uuid,
  ...rest
});

const errorReport = ({ uuid, error }) => ({
  type: REPORT_ERROR,
  uuid,
  error
});

export const fetchViews = () => async dispatch => {
  dispatch(requestViews());

  try {
    const { data, availableFilters } = await lookerApi.fetchViews();
    dispatch(loadViews({ data, availableFilters }));
  } catch (error) {
    dispatch(errorViews(error));
  }
};

export const fetchCustomView = specs => async dispatch => {
  const requestUUID = uuidv4();
  dispatch(requestCustomView({ requestUUID, specs }));

  try {
    const result = await lookerApi.fetchCustomView(specs);
    dispatch(
      loadCustomView({
        requestUUID,
        specs,
        result
      })
    );
  } catch (error) {
    dispatch(errorCustomView({ requestUUID, specs, error }));
  }
};

export const fetchReportList = userId => async dispatch => {
  dispatch(requestReportList({ userId }));

  try {
    const data = await lookerApi.fetchReportList(userId);
    dispatch(loadReportList({ userId, data }));
  } catch (error) {
    dispatch(errorReportList({ userId, error }));
  }
};

export const fetchReport = uuid => async dispatch => {
  dispatch(requestReport({ uuid }));

  try {
    const data = await lookerApi.fetchReport(uuid);
    const parsedFilters = parseFilters(data.filters);
    const withAsyncLabels = await addAsyncLabels(parsedFilters);
    await dispatch(updateFilters(withAsyncLabels, { syncWithUrl: false }));
    await dispatch(loadReport({ uuid, data }));
  } catch (error) {
    dispatch(errorReport({ uuid, error }));
  }
};
